import type { BLOCK_TYPE } from '../enums'
import type { ReferenceId } from '../ids'
import type { ContextParameterReference } from '../references'

import type { IBlock, BlockBaseSettings } from './base'
import type { VariablePriceReference } from './productsBlock'

export enum ProductRecommendationSource {
  /**
   * Use a contract ID (in context parameters) to fetch recommendations
   */
  CONTRACT = 'contract',
  /**
   * Use recommendation IDs to fetch recommendations
   */
  RECOMMENDATIONS = 'recommendations'
}

export interface ContractReference extends ContextParameterReference {
  meaning: 'source'
}

export interface ContractBasedProductRecommendationsBlock extends IBlock {
  type: BLOCK_TYPE.PRODUCT_RECOMMENDATIONS
  settings: BlockBaseSettings & {
    source: ProductRecommendationSource.CONTRACT
  }
  /**
   * Reference to Contract parameter used to fetch recommendations based on contract
   */
  references: Record<ReferenceId, ContractReference | VariablePriceReference>
}

export interface EntityBasedProductRecommendationsBlock extends IBlock {
  type: BLOCK_TYPE.PRODUCT_RECOMMENDATIONS
  settings: BlockBaseSettings & {
    source: ProductRecommendationSource.RECOMMENDATIONS
    /**
     * Product recommendation IDs (entity IDs) to fetch recommendations
     */
    recommendationIds?: string[]
  }
  references: Record<ReferenceId, VariablePriceReference>
}

export type ProductRecommendationsBlock =
  | ContractBasedProductRecommendationsBlock
  | EntityBasedProductRecommendationsBlock
